// extracted by mini-css-extract-plugin
module.exports = {"nodejsLogoDark":"NodejsLogo_nodejsLogoDark__hBQcp","nodejsLogoLight":"NodejsLogo_nodejsLogoLight__m8F4A"};